// @flow

import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Select } from 'client/components/common';
import css from './Filter.scss';

export const TYPES = {
	BOTTOM: 'bottom',
	TOP: 'top',
};

const text = {
	studyLabel: 'מקצוע',
	topLabel: 'התחתית',
	bottomLabel: 'הצמרת',
};

type type = string;
type dataType = any;
type Props = {
	onTypeChange: (options: type) => void,
	getStudies: () => Promise<any>,
	onOptionsChange: any,
	currentOptions: any,
	currentType: string,
	setData: (data: dataType) => void,
};

const Filter = (props: Props) => {
	const [studies, setStudies] = useState(null);
	const onStudyChange = React.useCallback((index: number, study: string) => {
		// flow-disable-next-line
		props.onOptionsChange(prevOptions => ({ ...prevOptions, study }));
	}, []);

	useEffect(() => {
		if (props.currentType === TYPES.BOTTOM) {
			props.onTypeChange(TYPES.TOP);
			props.setData({});
		}
	}, [props.currentOptions]);

	React.useEffect(() => {
		props.getStudies().then(result => {
			const omitList = [
				//
				'אזרחות 5',
				`היסטוריה לבי"ס דרוזי 5`,
				`עברית לבי"ס דרוזי 5`,
				`דת האיסלאם 2`,
			];

			const filteredResult = _.filter(result, subject => {
				return !omitList.includes(subject.replace(/\s+/g, ' ').trim());
			});

			setStudies(filteredResult);
		});
	}, []);

	if (!studies) {
		return null;
	}

	return (
		<div className={css.filter}>
			<Select
				className={css.select}
				options={studies}
				defaultOptionIndex={studies.indexOf(props.currentOptions.study)}
				onChange={onStudyChange}
				defaultLabel={text.studyLabel}
				labelPostfix=" יח'"
			/>
			<div className={css.types}>
				<button
					className={cn(css.typesBtn, css.typesBtnTop)}
					type="button"
					onClick={() => {
						props.onTypeChange(TYPES.TOP);
					}}
				>
					{text.bottomLabel}
				</button>
				<button
					className={cn(css.typesBtn, css.typesBtnBottom)}
					type="button"
					onClick={() => {
						props.onTypeChange(TYPES.BOTTOM);
					}}
				>
					{text.topLabel}
				</button>
			</div>
		</div>
	);
};

export default Filter;
